"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PiggyBox = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PiggyBox = function PiggyBox(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.744 4.675h2.675a.4.4 0 000-.8H5.744a.4.4 0 000 .8zm6.446 3.187a.8.8 0 10-.002-1.602.8.8 0 00.002 1.602zM.61 5.73l.456.656c-.192.134-.337.498-.237.766.104.274.455.31.724.298v-.159a4.8 4.8 0 014.8-4.8h3.24c.244 0 .484.024.719.06.783-.947 2.118-.952 2.118-.952v1.826a4.795 4.795 0 011.893 3.078h.874a.8.8 0 01.8.8V9.27a.8.8 0 01-.8.8h-1.112a4.797 4.797 0 01-1.655 2.186v1.827H9.757v-.9c-.055.002-.108.008-.163.008H7.082v.892H4.406v-1.306a4.8 4.8 0 01-2.852-4.386v-.14c-.028 0-.06.005-.086.005-.966 0-1.289-.563-1.386-.824-.22-.583.018-1.347.53-1.702z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.744 4.675h2.675a.4.4 0 000-.8H5.744a.4.4 0 000 .8zm6.446 3.187a.8.8 0 10-.002-1.602.8.8 0 00.002 1.602zM.61 5.73l.456.656c-.192.134-.337.498-.237.766.104.274.455.31.724.298v-.159a4.8 4.8 0 014.8-4.8h3.24c.244 0 .484.024.719.06.783-.947 2.118-.952 2.118-.952v1.826a4.795 4.795 0 011.893 3.078h.874a.8.8 0 01.8.8V9.27a.8.8 0 01-.8.8h-1.112a4.797 4.797 0 01-1.655 2.186v1.827H9.757v-.9c-.055.002-.108.008-.163.008H7.082v.892H4.406v-1.306a4.8 4.8 0 01-2.852-4.386v-.14c-.028 0-.06.005-.086.005-.966 0-1.289-.563-1.386-.824-.22-.583.018-1.347.53-1.702z",
    fill: "currentColor"
  }));
};

exports.PiggyBox = PiggyBox;
var _default = PiggyBox;
exports.default = _default;